import Store, { IStore } from '../store/index'
import createInstanceWrapper from '../utils/create-instance-wrapper'

const element = document.getElementById('goods');
let googds = element?.textContent || element?.innerText;
const n = googds?.lastIndexOf(",") as number;
googds = googds?.substring(0, n) as string + googds?.substring(n + 1);
let json: any

try {
	if (googds) {
		json = JSON.parse(googds as string)
	} else {
		json = JSON.parse(`{"goods": [	{
			"id": 1120,
			"type": 47,
			"img": "/upload/iblock/4f1/bcw0df11ny0rpa7ihxdv4s70pfq16es1.jpg",
			"name": "Номер подъезда",
			"price": "191.00",
			"size": "19 x 28.5 см"
		},
		{
			"id": 1121,
			"type": 44,
			"img": "",
			"name": "Подъездная до 5 этажей",
			"price": "205.00",
			"size": "25 x 24 см"
		},
		{
			"id": 986,
			"type": 53,
			"img": "/upload/iblock/100/7qpiqi7cjbadhffcgcagpdd2phod37gh.jpg",
			"name": "Подъездная от 6 до 14 этажей",
			"price": "318.00",
			"size": "25 x 41.5 см"
		},
		{
			"id": 985,
			"type": 82,
			"img": "",
			"name": "Подъездная от 15 до 30 этажей",
			"price": "431.00",
			"size": "25 x 59 см"
		},
		{
			"id": 1085,
			"type": 55,
			"img": "/upload/iblock/ae5/iv9ww50h0r3o8spggyky281a2f5i0xmt.jpg",
			"name": "Лифт",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1111,
			"type": 60,
			"img": "/upload/iblock/3e7/kwh9a48e8iug9vvz8sj2hyid4zw8as8v.jpg",
			"name": "Лифт грузовой",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1122,
			"type": 41,
			"img": "/upload/iblock/57f/5bnrosi8eb7vw8p3dimxunhykcklir6v.jpg",
			"name": "Правила пользования лифтом",
			"price": "191.00",
			"size": "19 x 28.5 см"
		},
		{
			"id": 1110,
			"type": 56,
			"img": "/upload/iblock/cb5/5guirbbdzgxgosjiszjzg018w5h5epfl.jpg",
			"name": "Лестница",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 984,
			"type": 80,
			"img": "/upload/iblock/22d/qrlgpmm7m1bo0nu261u6637llgx532w4.jpg",
			"name": "Выход влево",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1102,
			"type": 61,
			"img": "/upload/iblock/24b/dokexw12npicx0gwbaygvpzjgqjfkz32.jpg",
			"name": "Выход вправо",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 987,
			"type": 40,
			"img": "/upload/iblock/0f8/721fs1ci1g4pg3r5r47aaqgwwh73d131.jpg",
			"name": "Стрелка влево",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1123,
			"type": 84,
			"img": "/upload/iblock/7ea/12h1fzfb20ezihbrbwhn5t1n4ft5gcvr.jpg",
			"name": "Стрелка вправо",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 947,
			"type": 43,
			"img": "/upload/iblock/230/qpxk75bt4janko66cu3nwot3425euqb9.jpg",
			"name": "Квартиры на этаже",
			"price": "100.00",
			"size": "19 x 11 см"
		},
		{
			"id": 948,
			"type": 46,
			"img": "/upload/iblock/247/yp6y68i292ytu6bx84cgs1mg38pgqhtq.jpg",
			"name": "Квартиры на этаже влево",
			"price": "100.00",
			"size": "19 x 11 см"
		},
		{
			"id": 950,
			"type": 79,
			"img": "/upload/iblock/e45/e7up0qbkgw9qiichtl7p6ahzw9g0ylmj.jpg",
			"name": "Квартиры на этаже вправо",
			"price": "100.00",
			"size": "19 x 11 см"
		},
		{
			"id": 1104,
			"type": 45,
			"img": "/upload/iblock/ce8/18bzija3iqg75tu8cm4xp2a8s7al4pwx.jpg",
			"name": "Квартиры на этаже влево/вправо",
			"price": "100.00",
			"size": "19 x 11 см"
		},
		{
			"id": 1129,
			"type": 39,
			"img": "/upload/iblock/587/p7epxlxewnvn7w7v574pg3e1w9f96eqp.jpg",
			"name": "Этажная",
			"price": "191.00",
			"size": "19 x 28.5 см"
		},
		{
			"id": 1113,
			"type": 81,
			"img": "/upload/iblock/7e5/u82o87rsei9nxwwn61rfx9b77srwk4d8.jpg",
			"name": "Номерок квартирный",
			"price": "43.00",
			"size": "7 x 5 см"
		},
		{
			"id": 1114,
			"type": 51,
			"img": "/upload/iblock/877/5hua955mw6j3sffmxldz29ll5apagtsa.jpg",
			"name": "Номерок почтовый",
			"price": "35.00",
			"size": "6 x 3.5 см"
		},
		{
			"id": 953,
			"type": 71,
			"img": "/upload/iblock/955/v90ekxy61hk0xx3csvf7zy27np38pd4j.jpg",
			"name": "Техническое помещение",
			"price": "100.00",
			"size": "19 x 11 см"
		},
		{
			"id": 1100,
			"type": 62,
			"img": "/upload/iblock/c5c/o7z1vz8wtbbl1ksywlm2jtsnitwt9qf5.jpg",
			"name": "Видеонаблюдение",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1115,
			"type": 68,
			"img": "/upload/iblock/5e2/eh1jruzpjdl9etmj5hik9adag6l031ox.jpg",
			"name": "Охрана",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1105,
			"type": 57,
			"img": "/upload/iblock/044/301mn1oapqsv44tfp4fq234e79ba4dwx.jpg",
			"name": "Консьерж",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1116,
			"type": 77,
			"img": "/upload/iblock/31d/y1cfh4ktvrouul4kzg4uxx7ijnjyw9am.jpg",
			"name": "Парковка авто",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1119,
			"type": 48,
			"img": "/upload/iblock/234/49ni7p1nv71skc6d0gdjbbj0zgz6nftl.jpg",
			"name": "Парковочное место",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1118,
			"type": 49,
			"img": "/upload/iblock/a99/et4fi6lpnfr1t0zjm1pvgtah5doxwebk.jpg",
			"name": "Парковка запрещена",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1117,
			"type": 69,
			"img": "/upload/iblock/4b8/3t7efakugo0acrpba3jqdtsu06q665kl.jpg",
			"name": "Парковка велосипедная",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 951,
			"type": 70,
			"img": "/upload/iblock/899/oetcwkx2pfroth0y9bbr615ghpfa0g1u.jpg",
			"name": "Парковка для колясок",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1103,
			"type": 59,
			"img": "/upload/iblock/c5e/amqtbqpac2nqxmswv9dcf2msfk5lois1.jpg",
			"name": "Детская площадка",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 952,
			"type": 83,
			"img": "/upload/iblock/cc9/w3ygyvapxou48heofloi3cd5kmja17wf.jpg",
			"name": "Правила пользования детской площадкой",
			"price": "787.00",
			"size": "50 x 60 см"
		},
		{
			"id": 1101,
			"type": 54,
			"img": "/upload/iblock/136/i8fpx2dojbm0k08vxrfosj1faae53092.jpg",
			"name": "Выгул животных",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 946,
			"type": 78,
			"img": "/upload/iblock/655/vbn6ne2sqfgfwqyd2oiu12lfvttw8l3o.jpg",
			"name": "Выгул животных запрещён",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1112,
			"type": 52,
			"img": "/upload/iblock/d94/0xtgmbv1ezw2zuf971oh4stgaql1jlgz.jpg",
			"name": "Место для курения",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1106,
			"type": 50,
			"img": "/upload/iblock/5af/gepapaapbxxkycaoqytyxhb83euhaife.jpg",
			"name": "Курение запрещено",
			"price": "142.00",
			"size": "19 x 19 см"
		},
		{
			"id": 1124,
			"type": 72,
			"img": "/upload/iblock/c54/sbnnb85ax6ktr7efn55rfb12o6jp131b.jpg",
			"name": "Стенд 2 кармана",
			"price": "612.00",
			"size": "50 x 45 см"
		},
		{
			"id": 1125,
			"type": 73,
			"img": "/upload/iblock/0d7/jyspu7v10ckuiymqv40v8xso8153kqj1.jpg",
			"name": "Стенд 3 кармана",
			"price": "881.00",
			"size": "75 x 45 см"
		},
		{
			"id": 1126,
			"type": 74,
			"img": "/upload/iblock/545/o63y9x380zuiena92a1twydzpg02qgbw.jpg",
			"name": "Стенд 4 кармана",
			"price": "1023.00",
			"size": "50 x 80 см"
		},
		{
			"id": 1127,
			"type": 75,
			"img": "/upload/iblock/462/bff0e5othq3n9f3orxc05ob2ivhjy56c.jpg",
			"name": "Стенд 6 карманов",
			"price": "1470.00",
			"size": "75 x 80 см"
		},
		{
			"id": 1128,
			"type": 76,
			"img": "/upload/iblock/cab/mv61ulum62u0hhyfra4qfa1s00j2yuoi.jpg",
			"name": "Стенд 8 карманов",
			"price": "1881.00",
			"size": "98 x 80 см"
		},
		{
			"id": 1107,
			"type": 42,
			"img": "/upload/iblock/993/8ig3bvm98cotyvlr24849o6avg0hoem5.jpg",
			"name": "Ограничение скорости",
			"price": "361.00",
			"size": "⌀ 35"
		},
		{
			"id": 1108,
			"type": 67,
			"img": "/upload/iblock/abc/o3e8lpmsyuu9d7dgxuiwcjc91ge0l6r9.jpg",
			"name": "Осторожно дети",
			"price": "361.00",
			"size": "35 x 35 см"
		},
		{
			"id": 1109,
			"type": 58,
			"img": "/upload/iblock/854/6p4biaw30o9ll0p0hhiihamndpje5jus.jpg",
			"name": "Сигналить запрещено",
			"price": "361.00",
			"size": "⌀ 35"
		}
		]
	}`)
	}
} catch (e) {
	json = JSON.parse(`{"goods": [	{
    	"id": 1120,
        "type": 47,
		"img": "/upload/iblock/4f1/bcw0df11ny0rpa7ihxdv4s70pfq16es1.jpg",
		"name": "Номер подъезда",
		"price": "191.00",
		"size": "19 x 28.5 см"
	},
	{
    	"id": 1121,
        "type": 44,
		"img": "",
		"name": "Подъездная до 5 этажей",
		"price": "205.00",
		"size": "25 x 24 см"
	},
	{
    	"id": 986,
        "type": 53,
		"img": "/upload/iblock/100/7qpiqi7cjbadhffcgcagpdd2phod37gh.jpg",
		"name": "Подъездная от 6 до 14 этажей",
		"price": "318.00",
		"size": "25 x 41.5 см"
	},
	{
    	"id": 985,
        "type": 82,
		"img": "",
		"name": "Подъездная от 15 до 30 этажей",
		"price": "431.00",
		"size": "25 x 59 см"
	},
	{
    	"id": 1085,
        "type": 55,
		"img": "/upload/iblock/ae5/iv9ww50h0r3o8spggyky281a2f5i0xmt.jpg",
		"name": "Лифт",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1111,
        "type": 60,
		"img": "/upload/iblock/3e7/kwh9a48e8iug9vvz8sj2hyid4zw8as8v.jpg",
		"name": "Лифт грузовой",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1122,
        "type": 41,
		"img": "/upload/iblock/57f/5bnrosi8eb7vw8p3dimxunhykcklir6v.jpg",
		"name": "Правила пользования лифтом",
		"price": "191.00",
		"size": "19 x 28.5 см"
	},
	{
    	"id": 1110,
        "type": 56,
		"img": "/upload/iblock/cb5/5guirbbdzgxgosjiszjzg018w5h5epfl.jpg",
		"name": "Лестница",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 984,
        "type": 80,
		"img": "/upload/iblock/22d/qrlgpmm7m1bo0nu261u6637llgx532w4.jpg",
		"name": "Выход влево",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1102,
        "type": 61,
		"img": "/upload/iblock/24b/dokexw12npicx0gwbaygvpzjgqjfkz32.jpg",
		"name": "Выход вправо",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 987,
        "type": 40,
		"img": "/upload/iblock/0f8/721fs1ci1g4pg3r5r47aaqgwwh73d131.jpg",
		"name": "Стрелка влево",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1123,
        "type": 84,
		"img": "/upload/iblock/7ea/12h1fzfb20ezihbrbwhn5t1n4ft5gcvr.jpg",
		"name": "Стрелка вправо",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 947,
        "type": 43,
		"img": "/upload/iblock/230/qpxk75bt4janko66cu3nwot3425euqb9.jpg",
		"name": "Квартиры на этаже",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 948,
        "type": 46,
		"img": "/upload/iblock/247/yp6y68i292ytu6bx84cgs1mg38pgqhtq.jpg",
		"name": "Квартиры на этаже влево",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 950,
        "type": 79,
		"img": "/upload/iblock/e45/e7up0qbkgw9qiichtl7p6ahzw9g0ylmj.jpg",
		"name": "Квартиры на этаже вправо",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 1104,
        "type": 45,
		"img": "/upload/iblock/ce8/18bzija3iqg75tu8cm4xp2a8s7al4pwx.jpg",
		"name": "Квартиры на этаже влево/вправо",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 1129,
        "type": 39,
		"img": "/upload/iblock/587/p7epxlxewnvn7w7v574pg3e1w9f96eqp.jpg",
		"name": "Этажная",
		"price": "191.00",
		"size": "19 x 28.5 см"
	},
	{
    	"id": 1113,
        "type": 81,
		"img": "/upload/iblock/7e5/u82o87rsei9nxwwn61rfx9b77srwk4d8.jpg",
		"name": "Номерок квартирный",
		"price": "43.00",
		"size": "7 x 5 см"
	},
	{
    	"id": 1114,
        "type": 51,
		"img": "/upload/iblock/877/5hua955mw6j3sffmxldz29ll5apagtsa.jpg",
		"name": "Номерок почтовый",
		"price": "35.00",
		"size": "6 x 3.5 см"
	},
	{
    	"id": 953,
        "type": 71,
		"img": "/upload/iblock/955/v90ekxy61hk0xx3csvf7zy27np38pd4j.jpg",
		"name": "Техническое помещение",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 1100,
        "type": 62,
		"img": "/upload/iblock/c5c/o7z1vz8wtbbl1ksywlm2jtsnitwt9qf5.jpg",
		"name": "Видеонаблюдение",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1115,
        "type": 68,
		"img": "/upload/iblock/5e2/eh1jruzpjdl9etmj5hik9adag6l031ox.jpg",
		"name": "Охрана",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1105,
        "type": 57,
		"img": "/upload/iblock/044/301mn1oapqsv44tfp4fq234e79ba4dwx.jpg",
		"name": "Консьерж",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1116,
        "type": 77,
		"img": "/upload/iblock/31d/y1cfh4ktvrouul4kzg4uxx7ijnjyw9am.jpg",
		"name": "Парковка авто",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1119,
        "type": 48,
		"img": "/upload/iblock/234/49ni7p1nv71skc6d0gdjbbj0zgz6nftl.jpg",
		"name": "Парковочное место",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1118,
        "type": 49,
		"img": "/upload/iblock/a99/et4fi6lpnfr1t0zjm1pvgtah5doxwebk.jpg",
		"name": "Парковка запрещена",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1117,
        "type": 69,
		"img": "/upload/iblock/4b8/3t7efakugo0acrpba3jqdtsu06q665kl.jpg",
		"name": "Парковка велосипедная",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 951,
        "type": 70,
		"img": "/upload/iblock/899/oetcwkx2pfroth0y9bbr615ghpfa0g1u.jpg",
		"name": "Парковка для колясок",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1103,
        "type": 59,
		"img": "/upload/iblock/c5e/amqtbqpac2nqxmswv9dcf2msfk5lois1.jpg",
		"name": "Детская площадка",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 952,
        "type": 83,
		"img": "/upload/iblock/cc9/w3ygyvapxou48heofloi3cd5kmja17wf.jpg",
		"name": "Правила пользования детской площадкой",
		"price": "787.00",
		"size": "50 x 60 см"
	},
	{
    	"id": 1101,
        "type": 54,
		"img": "/upload/iblock/136/i8fpx2dojbm0k08vxrfosj1faae53092.jpg",
		"name": "Выгул животных",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 946,
        "type": 78,
		"img": "/upload/iblock/655/vbn6ne2sqfgfwqyd2oiu12lfvttw8l3o.jpg",
		"name": "Выгул животных запрещён",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1112,
        "type": 52,
		"img": "/upload/iblock/d94/0xtgmbv1ezw2zuf971oh4stgaql1jlgz.jpg",
		"name": "Место для курения",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1106,
        "type": 50,
		"img": "/upload/iblock/5af/gepapaapbxxkycaoqytyxhb83euhaife.jpg",
		"name": "Курение запрещено",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1124,
        "type": 72,
		"img": "/upload/iblock/c54/sbnnb85ax6ktr7efn55rfb12o6jp131b.jpg",
		"name": "Стенд 2 кармана",
		"price": "612.00",
		"size": "50 x 45 см"
	},
	{
    	"id": 1125,
        "type": 73,
		"img": "/upload/iblock/0d7/jyspu7v10ckuiymqv40v8xso8153kqj1.jpg",
		"name": "Стенд 3 кармана",
		"price": "881.00",
		"size": "75 x 45 см"
	},
	{
    	"id": 1126,
        "type": 74,
		"img": "/upload/iblock/545/o63y9x380zuiena92a1twydzpg02qgbw.jpg",
		"name": "Стенд 4 кармана",
		"price": "1023.00",
		"size": "50 x 80 см"
	},
	{
    	"id": 1127,
        "type": 75,
		"img": "/upload/iblock/462/bff0e5othq3n9f3orxc05ob2ivhjy56c.jpg",
		"name": "Стенд 6 карманов",
		"price": "1470.00",
		"size": "75 x 80 см"
	},
	{
    	"id": 1128,
        "type": 76,
		"img": "/upload/iblock/cab/mv61ulum62u0hhyfra4qfa1s00j2yuoi.jpg",
		"name": "Стенд 8 карманов",
		"price": "1881.00",
		"size": "98 x 80 см"
	},
	{
    	"id": 1107,
        "type": 42,
		"img": "/upload/iblock/993/8ig3bvm98cotyvlr24849o6avg0hoem5.jpg",
		"name": "Ограничение скорости",
		"price": "361.00",
		"size": "⌀ 35"
	},
	{
    	"id": 1108,
        "type": 67,
		"img": "/upload/iblock/abc/o3e8lpmsyuu9d7dgxuiwcjc91ge0l6r9.jpg",
		"name": "Осторожно дети",
		"price": "361.00",
		"size": "35 x 35 см"
	},
	{
    	"id": 1109,
        "type": 58,
		"img": "/upload/iblock/854/6p4biaw30o9ll0p0hhiihamndpje5jus.jpg",
		"name": "Сигналить запрещено",
		"price": "361.00",
		"size": "⌀ 35"
	}
    ]
}`)
	console.log(e)
}

let floorNumberPlate = json.goods.find((el: any) => el.type === 39)
let flatNumberPlate = json.goods.find((el: any) => el.type === 43)
let flatsArraysPlate = json.goods.find((el: any) => el.type === 46)
let plateExit = json.goods.find((el: any) => el.type === 61)
let plateLift = json.goods.find((el: any) => el.type === 55)
let plateLiftGruz = json.goods.find((el: any) => el.type === 60)
let plateArrow = json.goods.find((el: any) => el.type === 40)
let plateStairs = json.goods.find((el: any) => el.type === 56)
let plateNoSmiring = json.goods.find((el: any) => el.type === 50)
let numberOnPostBox = json.goods.find((el: any) => el.type === 51)
let conciergePlate = json.goods.find((el: any) => el.type === 57)
let veloParkingPlate = json.goods.find((el: any) => el.type === 57)
let infostand2 = json.goods.find((el: any) => el.type === 72)
let infostand3 = json.goods.find((el: any) => el.type === 73)
let infostand4 = json.goods.find((el: any) => el.type === 74)
let infostand6 = json.goods.find((el: any) => el.type === 75)
let infostand8 = json.goods.find((el: any) => el.type === 76)
let listOfFloors = json.goods.find((el: any) => el.type === 55)
let cctv = json.goods.find((el: any) => el.type === 62)

const house = `
{ "housePlates":{
  "activeEntrance":1,
  "Entrances": [{
    "flatsOnFloors": 3,
    "floors": [{
    "flatsOnFloor": 3,
    "floorNumberPlate": {
      "id": "${floorNumberPlate.id}",
      "name": "${floorNumberPlate.name}",
      "img": "${floorNumberPlate.img}",
      "number": 0,
      "count": 0,
      "price": ${floorNumberPlate.price},
      "size": "${floorNumberPlate.size}"
    },
    "flatNumberPlate": {
      "id": "${flatNumberPlate.id}",
      "name": "${flatNumberPlate.name}",
      "img": "${flatNumberPlate.img}",
      "count": 1,
      "price": ${flatNumberPlate.price},
      "size": "${flatNumberPlate.size}"
    },
    "flatsArraysPlate": {
        "id": "${flatsArraysPlate.id}",
        "name": "${flatsArraysPlate.name}",
        "img": "${flatsArraysPlate.img}",
            "withArray": false, 
            "start": 1,
            "end": 3,
            "count": 1,
            "price": ${flatsArraysPlate.price},
            "size": "${flatsArraysPlate.size}"
    },
    "plateExit":{
        "id": "${plateExit.id}",
        "name": "${plateExit.name}",
        "img": "${plateExit.img}",
      "count": 1,
      "price": ${plateExit.price},
      "size": "${plateExit.size}"
    },
    "plateLift": {
        "id": "${plateLift.id}",
        "name": "${plateLift.name}",
        "img": "${plateLift.img}",
      "count": 1,
      "price": ${plateLift.price},
      "size": "${plateLift.size}"
    },
    "plateLiftGruz":{
        "id": "${plateLiftGruz.id}",
        "name": "${plateLiftGruz.name}",
        "img": "${plateLiftGruz.img}",
      "count": 1,
      "price": ${plateLiftGruz.price},
      "size": "${plateLiftGruz.size}"
    },
    "plateArrow": {
        "id": "${plateArrow.id}",
        "name": "${plateArrow.name}",
        "img": "${plateArrow.img}",
      "count": 1,
      "price": ${plateArrow.price},
      "size": "${plateArrow.size}"
    },
    "plateStairs": {
        "id": "${plateStairs.id}",
        "name": "${plateStairs.name}",
        "img": "${plateStairs.img}",
      "count": 1,
      "price": ${plateStairs.price},
      "size": "${plateStairs.size}"
    },
    "plateNoSmiring": {
        "id": "${plateNoSmiring.id}",
        "name": "${plateNoSmiring.name}",
        "img": "${plateNoSmiring.img}",
      "count": 1,
      "price": ${plateNoSmiring.price},
      "size": "${plateNoSmiring.size}"
    }
}],
"informationStandOne": {
  "id": "${infostand2.id}",
  "name": "${infostand2.name}",
  "img": "${infostand2.img}",
  "count": 0,
  "price": ${infostand2.price},
  "size": "${infostand2.size}"
},
"informationStandTwo":  {
    "id": "${infostand3.id}",
    "name": "${infostand3.name}",
    "img": "${infostand3.img}",
    "count": 0,
    "price": ${infostand3.price},
    "size": "${infostand3.size}"
},
"informationStandTree": {
    "id": "${infostand4.id}",
    "name": "${infostand4.name}",
    "img": "${infostand4.img}",
    "count": 0,
    "price": ${infostand4.price},
    "size": "${infostand4.size}"
},
"informationStandFour":  {
    "id": "${infostand6.id}",
    "name": "${infostand6.name}",
    "img": "${infostand6.img}",
    "count": 0,
    "price": ${infostand6.price},
    "size": "${infostand6.size}"
},
"informationStandFive": {
    "id": "${infostand8.id}",
    "name": "${infostand8.name}",
    "img": "${infostand8.img}",
    "count": 0,
    "price": ${infostand8.price},
    "size": "${infostand8.size}"
},
    "numberOnPostBox": {
        "id": "${numberOnPostBox.id}",
        "name": "${numberOnPostBox.name}",
        "img": "${numberOnPostBox.img}",
      "count": 1,
      "price": ${numberOnPostBox.price},
      "size": "${numberOnPostBox.size}"
    },
    "conciergePlate": {
        "id": "${conciergePlate.id}",
        "name": "${conciergePlate.name}",
        "img": "${conciergePlate.img}",
      "count": 1,
      "price": ${conciergePlate.price},
      "size": "${conciergePlate.size}"
    },
    "veloParkingPlate": {
        "id": "${veloParkingPlate.id}",
        "name": "${veloParkingPlate.name}",
        "img": "${veloParkingPlate.img}",
      "count": 1,
      "price": ${veloParkingPlate.price},
      "size": "${veloParkingPlate.size}"
    },
    "buggyPlate": {
        "id": "${plateNoSmiring.id}",
        "name": "${plateNoSmiring.name}",
        "img": "${plateNoSmiring.img}",
      "count": 1,
      "price": ${plateNoSmiring.price},
      "size": "${plateNoSmiring.size}"
    },
    "technicalRoomPlate": {
        "id": "${plateNoSmiring.id}",
        "name": "${plateNoSmiring.name}",
        "img": "${plateNoSmiring.img}",
      "count": 1,
      "price": ${plateNoSmiring.price},
      "size": "${plateNoSmiring.size}"
    },
	"floorListPlate": {
        "id": "${listOfFloors.id}",
        "name": "${listOfFloors.name}",
        "img": "${listOfFloors.img}",
      "count": 1,
      "price": ${listOfFloors.price},
      "size": "${listOfFloors.size}"
    },
	"cctvPlare": {
        "id": "${cctv.id}",
        "name": "${cctv.name}",
        "img": "${cctv.img}",
        "count": 1,
        "price": ${cctv.price},
        "size": "${cctv.size}"
    }
}]}}`

let security = json.goods.find((el: any) => el.type === 68)
let animal = json.goods.find((el: any) => el.type === 54)
let noAnimal = json.goods.find((el: any) => el.type === 78)
let smoking = json.goods.find((el: any) => el.type === 52)
let childPlace = json.goods.find((el: any) => el.type === 59)
let childRools = json.goods.find((el: any) => el.type === 83)
let noParking = json.goods.find((el: any) => el.type == 49)
let attanChild = json.goods.find((el: any) => el.type == 67)
let speedLimit = json.goods.find((el: any) => el.type == 42)
let noSignal = json.goods.find((el: any) => el.type == 58)


const nearHousePlates = `
{ "houseAreaPlates": {
	"security": {
		"randId": "1",
		"id": "${String(security.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(security.price)},
		"size": "${security.size}",
		"description": "",
		"name": "${security.name}",
		"category": "nearHousePlate",
		"img": "${security.img}"
	},
	"animal": {
		"randId": "1",
		"id": "${String(animal.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(animal.price)},
		"size": "${animal.size}",
		"description": "",
		"name": "${animal.name}",
		"category": "nearHousePlate",
		"img": "${animal.img}"
	},
	"noAnimal": {
		"randId": "1",
		"id": "${String(noAnimal.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(noAnimal.price)},
		"size": "${noAnimal.size}",
		"description": "",
		"name": "${noAnimal.name}",
		"category": "nearHousePlate",
		"img": "${noAnimal.img}"
	},
	"smoking": {
		"randId": "1",
		"id": "${String(smoking.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(smoking.price)},
		"size": "${smoking.size}",
		"description": "",
		"name": "${smoking.name}",
		"category": "nearHousePlate",
		"img": "${smoking.img}"
	},
	"childPlace": {
		"randId": "1",
		"id": "${String(childPlace.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(childPlace.price)},
		"size": "${childPlace.size}",
		"description": "",
		"name": "${childPlace.name}",
		"category": "nearHousePlate",
		"img": "${childPlace.img}"
	},
	"childRools": {
		"randId": "1",
		"id": "${String(childRools.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(childRools.price)},
		"size": "${childRools.size}",
		"description": "",
		"name": "${childRools.name}",
		"category": "nearHousePlate",
		"img": "${childRools.img}"
	},
	"noParking": {
		"randId": "1",
		"id": "${String(noParking.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(noParking.price)},
		"size": "${noParking.size}",
		"description": "",
		"name": "${noParking.name}",
		"category": "nearHousePlate",
		"img": "${noParking.img}"
	},
	"attanChild":{
		"randId": "1",
		"id": "${String(attanChild.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(attanChild.price)},
		"size": "${attanChild.size}",
		"description": "",
		"name": "${attanChild.name}",
		"category": "nearHousePlate",
		"img": "${attanChild.img}"
	},
	"speedLimit": {
		"randId": "1",
		"id": "${String(speedLimit.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(speedLimit.price)},
		"size": "${speedLimit.size}",
		"description": "",
		"name": "${speedLimit.name}",
		"category": "nearHousePlate",
		"img": "${speedLimit.img}"
	},
	"noSignal":{
		"randId": "1",
		"id": "${String(noSignal.id)}",
		"count": 1,
		"color": "",
		"material": "",
		"price": ${Number(noSignal.price)},
		"size": "${noSignal.size}",
		"description": "",
		"name": "${noSignal.name}",
		"category": "nearHousePlate",
		"img": "${noSignal.img}"
	}
}}
`

let parkingPlate = json.goods.find((el: any) => el.type == 77)
let parkingNumber = json.goods.find((el: any) => el.type == 48)

const parkingPlates = `{
	"parkingPlates": {
		"parkingPlate": {
			"randId": "1",
			"id": "${String(parkingPlate.id)}",
			"count": 1,
			"color": "",
			"material": "",
			"price": ${Number(parkingPlate.price)},
			"size": "${parkingPlate.size}",
			"description": "",
			"name": "${parkingPlate.name}",
			"category": "parkingPlate",
			"img": "${parkingPlate.img}"
		},
		"parkingNumber": {
			"randId": "1",
			"id": "${String(parkingNumber.id)}",
			"count": 1,
			"color": "",
			"material": "",
			"price": ${Number(parkingNumber.price)},
			"size": "${parkingNumber.size}",
			"description": "",
			"name": "${parkingNumber.name}",
			"category": "parkingPlate",
			"img": "${parkingNumber.img}"
		}
	}
}`

const storeInstance = createInstanceWrapper<IStore>('Store')

export const createStore = () => {
	let initConfig
	let initNearHousePlates
	let initParkingPlates
	if (localStorage.getItem("configurator")) {
		// initConfig = JSON.parse(localStorage.getItem("configurator") as string)
		// let housePlates = { housePlates: {} } as any
		// housePlates.housePlates.activeEntrance = initConfig.activeEntrance
		// housePlates.housePlates.Entrances = initConfig.Entrances
		// housePlates.housePlates.CountFlatsInEntrances = initConfig.CountFlatsInEntrances
		// initConfig = housePlates
	} else {
		initConfig = JSON.parse(house)

	}

	initNearHousePlates = JSON.parse(nearHousePlates)
	initParkingPlates = JSON.parse(parkingPlates)


	const store = Store.create(
		{
			authStore: {},
			uiStore: {},
			dialogsStore: {},
			AnshlagStore: {
				...initParkingPlates,
				...initNearHousePlates
			},
			configuratorStore: initConfig
		}
	)
	storeInstance.set(store)
	return store
}

export default storeInstance
